module.exports = "/work-site/img/movie_status.0c393cd7.png";